<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger"  :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <el-button type="primary" v-if="tableAcl.indexOf('ToPlan') != -1" class="btn primary" @click="toPlan">生成采购计划</el-button>
          <el-dropdown v-if="tableAcl.indexOf('Print') != -1" @command="print">
            <el-button v-if="tableAcl.indexOf('Print') != -1" class="btn primary" type="primary">
              打印
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="0">请领单打印</el-dropdown-item>
              <el-dropdown-item command="1">请领单预览</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="270">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                    scope.row.status != 1 &&
                    scope.row.status != 2 &&
                    tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
    
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)" >复制</el-button>
                <!-- tableAcl.indexOf('StockUpPlease') != -1 -->
                <el-button type="text" v-if="
                    scope.row.state == 0 &&
                    scope.row.status == 2 
                  " class="margin-left20 color-blue" @click="createApplyOutStock(scope.row)">请领出库</el-button>
                  
                <!-- tableAcl.indexOf('StockUpPlease') != -1 -->
                <el-button type="text" v-if="
                    scope.row.state == 0 &&
                    scope.row.status == 2 
                  " class="margin-left20 color-blue" @click="FinishStockUpPlease(scope.row)">终止请领</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
  
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
          <el-table-column prop="no" width="175" label="备货请领单号">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="pressingStateName" width="80" label="紧急标识">
            <template slot-scope="scope">
              <span :class="getPressingStateClass(scope.row.pressingState)">{{
                scope.row.pressingStateName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column width="160" label="完成情况">
            <template slot-scope="scope">
              <el-progress :text-inside="true" :stroke-width="20" :percentage="
                  getPercentage(scope.row.totalReceivedNumber, scope.row.totalNumber)
                " color="#42b983" />
            </template>
          </el-table-column>
          <el-table-column  label="审批人" width="100" align="center" prop="approverNames" >
            <template slot-scope="scope">
              {{ scope.row.approverNames?scope.row.approverNames:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="statusName" label="流程状态" width="80" >
            <template slot-scope="scope">
              <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="applyDeptName" width="100" label="请领科室"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="目标库房"></el-table-column>
          <el-table-column prop="totalNumber" width="95" label="申请总数量"></el-table-column>
          <el-table-column prop="totalAmount" width="95" label="申请总金额"></el-table-column>
          <el-table-column prop="stateName" width="80" label="是否完成"></el-table-column>
          <el-table-column prop="createdUserName" width="80" label="申请人">
            <template slot-scope="scope">
              {{ scope.row.createdUserName?scope.row.createdUserName:'-' }}
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ownerDeptName" width="100" label="所属科室"></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.remark?scope.row.remark:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建时间" width="170">
            <template slot-scope="scope">
              {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
            </template>
          </el-table-column>
          <el-table-column prop="operation" fixed="right" label="操作" width="270">
            <template slot-scope="scope">
              <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
              <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
              <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
  
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <el-button type="text" class="margin-left20 color-blue" @click="handleCopy(scope.row)" >复制</el-button>
              <!-- tableAcl.indexOf('StockUpPlease') != -1 -->
              <el-button type="text" v-if="
                  scope.row.state == 0 &&
                  scope.row.status == 2 
                " class="margin-left20 color-blue" @click="createApplyOutStock(scope.row)">请领出库</el-button>
                
              <!-- tableAcl.indexOf('StockUpPlease') != -1 -->
              <el-button type="text" v-if="
                  scope.row.state == 0 &&
                  scope.row.status == 2 
                " class="margin-left20 color-blue" @click="FinishStockUpPlease(scope.row)">终止请领</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
 

      <el-dialog :title="'是否终止当前请领单' + finishForm.no" :visible.sync="finishVisible" width="40%" :close-on-click-modal="false">
        <el-form ref="finishForm" :model="finishForm" :rules="finishFormRules" label-width="90px">
          <el-row>
            <el-col>
              <el-form-item prop="reason" label="终止原因">
                <el-input v-model="finishForm.reason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="finishVisible = false">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="finishSubmit">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <info :show="showInfo" :id="id" @handleClose="closeInfo"></info> -->
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetStockUpPleases,
  GetStockUpPleasePrintData,
  FinishStockUpPlease,
  GetPurchaseApplys,
  GetPurchaseApplyPrintData,
  // CreatePurchasePlanByApplyIds,
  RemoveStockUpPlease,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  WhetherOptions,
  PlanStateOptions,
  PurchaseApplyCategoryOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetStockUpPleases,
      RemoveAction: RemoveStockUpPlease,
      PrintAction: GetStockUpPleasePrintData,
      // exportAction: ExportAcceptOutStock,
      editPath: "pleaseCollect-edit",
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        state: 0,
        stateName: 0,
      },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 新增、编辑的数据
      // form: {},
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      WhetherOptions: WhetherOptions,
      PlanStateOptions: PlanStateOptions,
      PurchaseApplyCategoryOptions: PurchaseApplyCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "请领科室",
          type: "select",
          code: "applyDeptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "供应商产品名称",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        // {
        //   name: "供货商产品",
        //   type: "select",
        //   code: "supplierProductId",
        //   filterMethod: this.getSupplierProductsNoDebounce1,
        //   data: [],
        // },
     
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "是否已完成",
          type: "select",
          code: "state",
          data: WhetherOptions,
          defaultValue: 0,
        },
        {
          name: "目标库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getOneLevelWarehouses,
          data: [],
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "创建日期",
          type: "date",
          code: "date",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
      ],

      finishVisible: false,
      finishForm: {},
      finishFormRules: {
        reason: [
          {
            required: true,
            message: "请输入终止原因",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
   

    handleCopy (row) {
      this.routePushWithParams("/pleaseCollect-edit", this.query, {
        formMode: 2,
        id: row.id,
        isCopy: 1,
      });
    },
    toPlan () {
      const length = this.ids.length;
      if (length === 0) {
        this.$my_message(`请选择数据`, "warning");
        return;
      }
      let statusDatas = this.multipleSelection.filter((e) => e.status != 2);
      if (statusDatas != null && statusDatas.length > 0) {
        this.$my_message(`存在不是生效状态的请领单，不能生成采购计划`, "warning");
        return;
      }
      let stateDatas = this.multipleSelection.filter((e) => e.state == 1);
      if (stateDatas != null && stateDatas.length > 0) {
        this.$my_message(`存在已完成的请领单，不能生成采购计划`, "warning");
        return;
      }
      let applyStatusDatas = this.multipleSelection.filter((e) => e.applyStatus);
      if (applyStatusDatas != null && applyStatusDatas.length > 0) {
        this.$my_message(`不能勾选已生成或计划生成中的请领单`, "warning");
        return;
      }

      let oneLevelWarehouseIds = Array.from(new Set(this.multipleSelection.map((e) => e.oneLevelWarehouseId)));
      if (oneLevelWarehouseIds != null && oneLevelWarehouseIds.length > 1) {
        this.$my_message(`所选请领单存在目标库房不一致，不能生成采购计划`, "warning");
        return;
      }

      const h = this.$createElement;
      let content = [h("p", "确定要生成采购计划吗？")];
      let otherOneLevelWarehouseIds = this.multipleSelection.filter(
        (e) => e.oneLevelWarehouseId != this.multipleSelection[0].oneLevelWarehouseId
      );
      if (otherOneLevelWarehouseIds && otherOneLevelWarehouseIds.length > 0) {
        // message += "<br/><span style='color:red'>存在目标库房不一致</span>";
        content.push(
          h(
            "p",
            {
              style: "color:red",
            },
            "存在目标库房不一致"
          )
        );
      }

      this.$confirm("提示", {
        title: "提示",
        type: "warning",
        message: h("div", content),
      }).then(() => {
        // return CreatePurchasePlanByApplyIds({ ids: this.ids })
        this.query.applyIds = this.ids;
        this.routePushWithParams("/spd-purchase-plan-edit", this.query, {
          formMode: 1,
        });
      });
      // .then(res => {
      //   if (!res.successful) {
      //     return;
      //   }
      //   this.$my_message(`生成成功`, "success");
      //   this.getData()
      //   this.ids = []
      //   this.$refs.multipleTable.clearSelection();
      // })
    },
    createApplyOutStock (row) {
      this.$router.push({
        name: "StockUpCheckEdit", // module里的code
        params: this.query,
        query: {
          applyId: row.id,
          formMode: 1,
          resouce: 1,
        }, //resouce 来源，在请领出库页面中判断
      });
    },
    FinishStockUpPlease (row) {
      if (row.state == 1) {
        this.$my_message("该请领单已完成，不用在终止");
        return;
      }

      this.finishForm = {
        no: row.no,
        id: row.id,
        reason: "",
      };
      this.finishVisible = true;
    },
    finishSubmit () {
      this.$refs["finishForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        FinishStockUpPlease(this.finishForm).then((res) => {
          this.$my_message(`已终止请领单`, "success");
          this.finishVisible = false;
          this.getData();
        });
      });
    },
    // print (command) {
    //   const length = this.ids.length
    //   if (length !== 1) {
    //     this.$my_message('请选择一条数据', 'warning')
    //     return
    //   }

    //   var id = this.ids[0]
    //   GetPurchaseApplyPrintData({ id: id, type: command })
    //     .then(res => {
    //       var result = res.returnData

    //       var printData = this.printDataConvert(result.printData)
    //       this.sendPrintMessage(JSON.stringify(printData));
    //       this.getData();
    //     })
    // },
  },
  created () {
    // 分页组件默认值需要早created
    // if (this.$route.params && JSON.stringify(this.$route.params) != '{}') {
    //   this.query = this.$route.params
    // }
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params && JSON.stringify(this.$route.params) != '{}') {
    //   this.$refs["selectFilter"].query = this.query
    // }
    // this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
